import React from 'react';
import { ODGlobalProvider } from './ODGlobalProvider';
export var ODGlobal = function (_a) {
    var def = _a.def, children = _a.children;
    return React.createElement(ODGlobalProvider, { def: def }, children);
};
//# sourceMappingURL=ODGlobal.js.map